<template>
<div
    style="text-align: right; margin-top: 15px;"
>

    <v-btn
        v-if="has_features_listener"
        class="mx-2" fab dark small color="primary"
        v-on:click="$emit('features')"
    >
        <v-icon dark>mdi-format-list-bulleted</v-icon>
    </v-btn>

    <v-btn
        v-if="has_add_listener"
        class="mx-2" fab dark small color="primary"
        v-on:click="$emit('add')"
    >
        <v-icon dark>mdi-plus</v-icon>
    </v-btn>

</div>
</template>

<script>
export default {
    computed: {
        has_add_listener() {
            return this.$listeners && this.$listeners['add'];
        },

        has_features_listener() {
            return this.$listeners && this.$listeners['features'];
        }
    },
}
</script>

<style lang="scss" scoped>
</style>